export default __webpack_public_path__ + "static/media/Logo.f21f8a49.svg";